import {TranslationKey} from '@enums'
import {Box, Stack, Typography} from '@mui/material'

import React, {useEffect} from 'react'

import {renderFormField} from 'common'

import logo from '@images/amplio-logo-light.png'

import {useLoginModel} from './login-model'
import {
  ContentContainer,
  LeftContentContainer,
  WelcomeMessageContainer,
  LoginButton,
  InfoText,
  RightContentContainer,
  RightContentOverlay,
  imageStyle,
  LeftContentInputsWrapper,
  HcsLoginButton,
} from './style'

/**
 * Login page
 */
export function LoginPage() {
  const {onLogin, t, loginFormFields, onHcsLogin, loading, checkLogin} = useLoginModel()

  useEffect(() => {
    console.log("hey")
    checkLogin()
  }, [])

  // if (loading) return <div>Loading...</div>

  return (
    <ContentContainer>
      <LeftContentContainer>
        <Box component="img" src={logo} sx={imageStyle} />

        <LeftContentInputsWrapper>
          <WelcomeMessageContainer gap={1}>
            <Typography variant="h1">{t(TranslationKey['Welcome back'])}</Typography>
            <Typography>{t(TranslationKey['Sign in to start managing your contracts.'])}</Typography>
          </WelcomeMessageContainer>
          <Stack gap={2} alignItems={'center'}>
            {loginFormFields.map((item, index) => (
              <Stack key={`login-form-input-${index}`}>{renderFormField(item)}</Stack>
            ))}

            <LoginButton onClick={() => onLogin()}>{t(TranslationKey['Sign in'])}</LoginButton>
            <HcsLoginButton onClick={() => onHcsLogin()}>{t(TranslationKey['Husqvarna Sign in'])}</HcsLoginButton>
          </Stack>
          <InfoText>
            <Typography fontSize={'0.75rem'}>
              {t(TranslationKey['If you do not have an account, please contact your system administrator.'])}
            </Typography>
          </InfoText>
        </LeftContentInputsWrapper>
      </LeftContentContainer>
      <RightContentContainer>
        <RightContentOverlay />
      </RightContentContainer>
    </ContentContainer>
  )
}
